'use strict';

module.exports = function (email) {
    const split = email.split('@'); 
    var regex = email.match(/^[A-Za-z0-9_.+\/?-]+@[a-zA-Z0-9]+[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/) && split.length == 2 && !split[0].match(/[\s,()\[\];:%*<>\""{}]/) && !split[0].match(/^[\.]|[\x01-\x1F]|[\x7f-\xff]/) && !split[1].match(/^\.|\.\.|\.$|[^a-zA-Z0-9\.\-\_]/);
    return regex;
};
